//#region src/quicksand_record_type.ts
var QuicksandRecordType = /* @__PURE__ */ function(QuicksandRecordType) {
	QuicksandRecordType[QuicksandRecordType["Create"] = 1] = "Create";
	QuicksandRecordType[QuicksandRecordType["Update"] = 2] = "Update";
	QuicksandRecordType[QuicksandRecordType["Delete"] = 3] = "Delete";
	QuicksandRecordType[QuicksandRecordType["SyncWarning"] = 4] = "SyncWarning";
	QuicksandRecordType[QuicksandRecordType["SyncSummary"] = 5] = "SyncSummary";
	QuicksandRecordType[QuicksandRecordType["Archive"] = 6] = "Archive";
	QuicksandRecordType[QuicksandRecordType["Unarchive"] = 7] = "Unarchive";
	/** @deprecated No longer used; deprecated instead of deleted to deter reuse of value */
	QuicksandRecordType[QuicksandRecordType["DayPartChangeDeprecated"] = 8] = "DayPartChangeDeprecated";
	return QuicksandRecordType;
}(QuicksandRecordType || {});
//#endregion
export { QuicksandRecordType };

//# sourceMappingURL=quicksand_record_type.js.map